module.exports = __webpack_public_path__ + "static/img/successful-payment.a6dca62a.svg";